export const faqItems = [
  {
    question: "Welche Leistungen bietet Tür- und Torservice Britz an?",
    answer:
      "Wir unterstützen private, gewerbliche und öffentliche Kunden bei Garagentoren, Industrietoren, Brandschutztüren und -toren, UVV-Prüfungen, Einbruchschutz, Verladebrücken und Metallbauarbeiten.",
  },
  {
    question: "In welchem Gebiet ist TTS Britz im Einsatz?",
    answer:
      "Unser Betrieb sitzt in Öhringen-Eckartsweiler. Wir sind vor allem in Öhringen, Künzelsau, Schwäbisch Hall, Heilbronn und der umliegenden Region Hohenlohe tätig.",
  },
  {
    question: "Führt TTS Britz auch Wartungen und Reparaturen an Toranlagen durch?",
    answer:
      "Ja, wir übernehmen Wartung, Reparatur und Instandsetzung von Garagentoren, Industrietoren, Türen und weiteren Toranlagen fachgerecht und zuverlässig.",
  },
  {
    question: "Werden UVV-Prüfungen für Tore und Türen angeboten?",
    answer:
      "Ja, wir führen UVV-Prüfungen an kraftbetätigten Türen, Toren und Toranlagen durch und unterstützen dabei, die Betriebssicherheit regelmäßig zu prüfen.",
  },
  {
    question: "Kann ich mich zu Einbruchschutz und Sicherheitstechnik beraten lassen?",
    answer:
      "Ja, wir beraten zu mechanischem Einbruchschutz, Zusatzsicherungen und Fenstergittern und montieren passende Lösungen für Türen, Fenster und Tore.",
  },
  {
    question: "Wie kann ich einen Termin oder ein Angebot anfragen?",
    answer:
      "Sie erreichen uns telefonisch unter 07941 33 51 4 oder über das Kontaktformular auf der Webseite. Wir melden uns anschließend zur Abstimmung Ihres Anliegens zurück.",
  },
];
